import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Loading } from "./Loading";

function ProgrammerStandOut() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

 
   

   useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/programs`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setData(events);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);


  if (!data) {
    return <div><Loading /></div>;
  }

  return (
    <section className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 relative overflow-hidden bg-none">
      {/* Subtle background ambient blur blobs */}
      <div className="absolute -z-10 top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full pointer-events-none overflow-hidden opacity-40">
        <div className="absolute top-12 left-10 w-72 h-72 bg-indigo-300 rounded-full blur-[120px]" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-200 rounded-full blur-[150px]" />
      </div>

      {/* Modern Header Section */}
      <div className="max-w-3xl mx-auto text-center mb-16 sm:mb-20">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight leading-tight mb-6">
          <span className="bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-600 bg-clip-text text-transparent">
            {t(data.heading)}
          </span>
        </h2>
        <div className="w-24 h-1.5 bg-gradient-to-r from-blue-500 via-indigo-500 to-violet-600 rounded-full mx-auto" />
      </div>

      {/* Grid of features */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 relative z-10">
        {data.features.map((feature, index) => (
          <div 
            key={feature.id} 
            className="group bg-white rounded-[2rem] p-6 sm:p-8 shadow-sm hover:shadow-2xl hover:scale-[1.01] border border-slate-100 hover:border-indigo-100 transition-all duration-300 flex flex-col gap-6 relative"
          >
            <div className="relative w-full aspect-[16/10] rounded-2xl overflow-hidden bg-slate-50 border border-slate-100/50">
              <img
                src={`${process.env.REACT_APP_COURSE_API_BASEURL}${feature.imageUrl}` || "/placeholder.svg"}
                alt={t(feature.title)}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                sizes="(max-width: 768px) 100vw, 50vw"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/Adaptive.jpg";
                }}
              />
            </div>

            {/* Content info details */}
            <div className="space-y-3">
              <h3 className="text-xl sm:text-2xl font-black text-slate-900 group-hover:text-indigo-600 transition-colors duration-200">
                {t(feature.title)}
              </h3>
              <p className="text-sm sm:text-base text-slate-500 font-medium leading-relaxed">
                {t(feature.description)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ProgrammerStandOut;
